import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';
import { ModificationRequestHistoryDescriptor } from './model/modification.request.history';

@Injectable()
export class ModificationRequestHistoryService extends RESTServiceBase {

  constructor(
    private authService: AuthService,
    private config: AppConfig
  ) {
    super(
      'v1',
      'ModificationRequestHistoryManagement',
      authService,
      config.CMSConfig
    );

  }

  public getModificationRequests(view?: View): Promise<List<ModificationRequestHistoryDescriptor>> {
    return super.get<List<ModificationRequestHistoryDescriptor>>(undefined, view);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public getById(id: string): Promise<ModificationRequestHistoryDescriptor> {
    return super.get<ModificationRequestHistoryDescriptor>(id);
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/modification.request.history/modification.request.history.service.ts